import React from 'react';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
var NullIcon = function () { return (React.createElement("span", { style: { display: 'block', width: '1px', height: '24px' } })); };
var DummySubscribedVariant = function (_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'medium' : _b, href = _a.href, onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(SolidButton, { className: className, size: size, variant: 'approval-green', priority: "secondary", href: href, icon: NullIcon, onClick: onClick }, t('deviation.tier.subscribed')));
};
DummySubscribedVariant.displayName = 'DummySubscribedVariant';
export default DummySubscribedVariant;
//# sourceMappingURL=DummySubscribed.js.map